import React, { useEffect, useState } from 'react';
import { UpdatableField } from './TextField';
import { Box, IconButton, InputAdornment } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

// const textColor = {
//     "& .MuiInputBase-input.Mui-disabled": {
//         WebkitTextFillColor: "#fff",
//         textAlign: "center",
//     },
// }

// `jumpMin` (optional, > 1) makes the stepper snap between 0 and that minimum:
// the first "+" jumps 0 -> jumpMin, and "-" at jumpMin clears back to 0. This lets
// a caller require "0 or at least N" without changing the default 1-by-1 behavior.
function PlusOrMinusButton({ name = "", label = "", value = 1, min = 0, max = 5, jumpMin = 0, handleChange, size = "small", disabled = false }) {
    const [num, setNum] = useState(value);
    const handleMinusBtn = () => {
        const current = parseInt(num);
        if (jumpMin > 1 && current <= jumpMin) {
            if (current > 0) setNum(0);
            return;
        }
        if (current > min) {
            setNum(current - 1);
        }
    }
    const handlePlusBtn = () => {
        const current = parseInt(num);
        if (current >= max) return;
        if (jumpMin > 1 && current === 0) {
            setNum(Math.min(jumpMin, max));
            return;
        }
        setNum(current + 1);
    }

    useEffect(() => {
        handleChange(num);
        // eslint-disable-next-line
    }, [num])

    return (
        <Box width="100%" sx={{ position: "relative" }}>
            <UpdatableField
                fullWidth
                required
                size={size}
                // type="number"
                // value={num}
                // sx={textColor}
                name={name}
                label={label}
                inputProps={{ min: min, max: max }}
                disabled
                InputProps={{
                    startAdornment: (
                        <InputAdornment sx={{ ml: -1 }} position="start">
                            <IconButton color='primary' onClick={handleMinusBtn} disabled={disabled}>
                                <Remove />
                            </IconButton>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment sx={{ mr: -1 }} position="end">
                            <IconButton color='primary' onClick={handlePlusBtn} disabled={disabled}>
                                <Add />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <h4 style={{
                position: "absolute",
                left: "50%",
                top: size === "small" ? "2%" : "13%",
                transform: "translate(-50%, -50%)",
            }}>
                {num}
            </h4>
        </Box>
    )
}

export default PlusOrMinusButton